export let EventState;
(function (EventState) {
  EventState["INITIATED"] = "initiated";
  EventState["SUCCEEDED"] = "succeeded";
  EventState["FAILED"] = "failed";
})(EventState || (EventState = {}));